import React from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import CheckIcon from '@material-ui/icons/Check'
import StepConnector from '@material-ui/core/StepConnector'

const useStyles = makeStyles(theme => ({
    root: {
        /* marginTop: 12,
        paddingBottom: 12 */
    },
    stepIconRoot: {
        color: theme.secondary,
        display: 'flex',
        height: 22,
        width: 22,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        background: '#F8F8F8',
        zIndex: 9
    },
    active: {
        color: theme.blueDark
    },
    circleIcon: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor'
    },
    completedIcon: {
        color: theme.blueDark,
        zIndex: 1,
        fontSize: 18
    },
    stepLabel: {
        display: 'flex',
        flexDirection: 'column',
        fontFamily: theme.fontFamily
    },
    stepLabelActive: {
        fontFamily: theme.fontFamily,
        color: theme.textPrimary
    },
    stepLabelTxt: {
        fontWeight: 800,
        fontSize: '14px'
    },
    stepQuestionTxt: {
        fontWeight: 400,
        fontSize: '14px'
    }
}))

export default function CustomStepper(props) {
    const classes = useStyles()

    const { steps, activeStep, ...restProps } = props
    const restClasses = { ...restProps }.className

    return (
        <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<CustomStepConnector />}
            classes={{
                root: classNames(classes.root, restClasses)
            }}
        >
            {steps.map(step => {
                return (
                    <Step key={step.label}>
                        <StepLabel
                            StepIconComponent={StepIcon}
                            classes={{
                                label: classes.stepLabel,
                                active: classes.stepLabelActive
                            }}
                        >
                            <span className={classes.stepLabelTxt}>
                                {step.label}
                            </span>
                            <span className={classes.stepQuestionTxt}>
                                {step.question}
                            </span>
                        </StepLabel>
                    </Step>
                )
            })}
        </Stepper>
    )
}

const CustomStepConnector = withStyles(theme => ({
    alternativeLabel: {
        top: 10,
        left: '-50%',
        right: '50%'
    },
    active: {
        '& $line': {
            borderColor: theme.blueDark
        }
    },
    completed: {
        '& $line': {
            borderColor: theme.blueDark
        }
    },
    line: {
        borderColor: theme.secondary,
        borderTopWidth: 1,
        borderRadius: 1
    }
}))(StepConnector)

function StepIcon(props) {
    const classes = useStyles()
    const { active, completed } = props

    return (
        <div
            className={classNames(classes.stepIconRoot, {
                [classes.active]: active
            })}
        >
            {completed ? (
                <CheckIcon className={classes.completedIcon} />
            ) : (
                <div className={classes.circleIcon} />
            )}
        </div>
    )
}
